import { useState } from "react";
import { taskService } from "@miplatform/api";
import { ATTEMPT_STATUSES, HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { toastService } from "@miplatform/toast";
import { getGUIDArray, isBefore, } from "@miplatform/utils";
import { useGlobalManagerApproval } from "@mibuildweb/components";


export const useHoldsViewModel = ({
  appendOrderTypeColor,
  viewConfig = {},
} = {}) => {
  const stateManager = useComponentState();
  const [holdsData, setHoldsData] = useState([]);
  const { executeApiRequest } = useGlobalManagerApproval();

  const handleSetHoldsData = (data) => {
    setHoldsData(appendOrderTypeColor(data));
  };

  const getHoldsData = () => {
    stateManager.run(async () => {
      const orderTemplateIds = (viewConfig.orderTemplates || []).map(
        (template) => template.id
      );
      const { status, data } = await taskService.attempts.getAll({
        filters: {
          attemptStatus: { eq: ATTEMPT_STATUSES.HOLD },
          isOrderFollowupDue: false,
          assignment: {
            order: {
              holdCalendarId: {
                type: "guid",
                value: viewConfig.id,
              },
              ...(orderTemplateIds?.length > 0 && {
                orderTemplateId: {
                  in: getGUIDArray(orderTemplateIds),
                },
              }),
            },
          },
          ...viewConfig?.filter,
        },
        sort: "modifiedOn desc",
      });

      if (status === HTTP_STATUSES.OK) {
        handleSetHoldsData(
          data.sort((a, b) =>
            isBefore(
              a?.assignment?.order?.followUpDate,
              b?.assignment?.order?.followUpDate
            )
              ? 1
              : -1
          )
        );
      }
    });
  };

  const handleReleaseOrder = ({ attempt, reason, releaseDate }) => {
    return stateManager.run(async () => {
      const data = releaseDate ? { reason, releaseDate } : { reason };

      const response = await taskService.order.release({
        orderId: attempt.orderId,
        data,
        modifiedOn: attempt.orderModifiedOn,
        toastMessageConfig: {
          success: {
            text: "Order Released",
            subtext: `${attempt.home.address.addressLine1} was released from hold`,
          },
        },
      });

      return response;
    });
  };

  const rescheduleOrder = (orderId, data) => {
    return stateManager.run(async () => {
      const options = await taskService.order.getRescheduleOptions({
        orderId,
        data,
      });
      const response = await executeApiRequest({
        options,
        noInitialErrorMessage: true,
      });
      if (response.status === HTTP_STATUSES.OK) {
        toastService.success({ text: "Order rescheduled successfully." });
      }
      return response.status === HTTP_STATUSES.OK;
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    holdsData,
    handleReleaseOrder,
    getHoldsData,
    rescheduleOrder,
  };
};
